export class MajorsNCareers {
  majorCode: number[] = [];
  industry: number[] = [];
  careers: number[] = [];
}
